<template>
  <div class="col-2">
    <div class="card border-0 shadow-sm" @dblclick="folderClicked(folder)">
      <div class="card-body text-center">
        <div class="folder-icon">
          <i class="fas fa-folder fa-2x"></i>
          <p class="mb-0">{{ folder }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["folder"],
  methods: {
    folderClicked(folder) {
      this.$emit("clicked", folder);
    }
  }
};
</script>

<style>
</style>